import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { County } from 'src/app/angular-elements/shared/interfaces/zip-county-response.interface';
import { ErrorFn } from 'src/app/shared/services/form-validation.service';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ZipCountyStateStructure } from 'src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
import { GlobalShadowStyleDirective } from '@ptl/global-components';

@Component({
    selector: 'app-zip-county-inputs',
    templateUrl: './zip-county-inputs.component.html',
    styleUrls: ['./zip-county-inputs.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class ZipCountyInputsComponent extends GlobalShadowStyleDirective implements OnInit {
  @Input() submitUrl: string;

  countyForm: UntypedFormGroup;
  selectCountyText: string;
  counties: County[];
  getErrors: ErrorFn;
  isSingleCounty = true;
  zipCodeRegion: string;

  /** Stores the selected county */
  saveableCounty: County;
  saveableZipCode: string;

  stateValues: { zipCode: string; };
  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private commonUtilityService: CommonUtilityService
    ) { 
      super();
    }

  ngOnInit() {
    const zipcountyState: ZipCountyStateStructure = this.reducerUtilityService.getState(
      'ZipCounty'
    );

    if (zipcountyState.zipCode) {
      this.stateValues = {
        zipCode: zipcountyState.zipCode
      };
    }

  }

  zipCountyChanged(value: { county: County; zipCode: string; }) {
    this.saveableCounty = value.county;
    this.saveableZipCode = value.zipCode;
    this.zipCodeRegion = value.county.region;
  }

  gotoURL(url: string) {
    if (this.saveableCounty && this.saveableZipCode) {
      this.commonUtilityService.saveCountyZipData(this.saveableCounty, this.saveableZipCode);

      setTimeout(() => {
        if (url) {
          window.location.href = `./${url}`;
        } else {
          window.location.reload();
        }
      }, 100)

    }
  }
}
